import React from 'react';
import { Typography, Box } from '@mui/material';

const ViewRecommendation = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                View Recommendations
            </Typography>
            <Typography variant="body1">
                List of recommendations based on sensor data.
            </Typography>
        </Box>
    );
}

export default ViewRecommendation;
